import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Cache } from 'aws-amplify';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { 
  addOvertimeEntries, 
  setOvertimeEntries, 
  DRAFT, 
  REJECTED, 
  APPROVED, 
  HAS_REQUIRED_HOURS, 
  OVER_REQUIRED_HOURS, 
  OVER_WEEKEND_HOURS, 
  BELOW_REQUIRED_HOURS, 
  WORK_HOURS, 
  FUTURE_DATE } from '../../store/actions/timesheet/timesheetActions';
import { fetchHolidays } from '../../store/actions/holidays/holidaysActions';

import moment from 'moment';

class TotalDayHoursSpent extends Component {

  componentDidMount() {
    this.props.fetchHolidays();
  }

  componentWillUnmount() {
    Cache.setItem('hideOTPopoverOnLoad', true);
  }
  
  render() {
    const holidays = this.props.holidays.holidays;

    const durationEntries = this.props.timesheets.durationEntries;
    const timesheetDates = this.props.timesheets.timesheetDates;
    let overTimeEntries = this.props.timesheets.overTimeEntries;
    const timesheet = this.props.timesheets.timesheet;
    let totalDurations = '';
    let colspan = 3;

    let arrOTEntries = [];

    overTimeEntries.length && overTimeEntries.filter(data => {
      return data.isTag ? true : false;
    }).forEach(overTimeEntry => {
      arrOTEntries.push(overTimeEntry.entryDate);
    })

    totalDurations = timesheetDates.map( (timesheetDate, key) => {
      const timesheetMoment = moment(timesheetDate.shortHandDate); 

      let spendIndicator = HAS_REQUIRED_HOURS;
      let total = 0;
      let holidaySpan = '';
      durationEntries.filter(data => {
        if (data.date === timesheetDate.shortHandDate) {
          return data;
        }
        return null;
      }).forEach(durationEntry => {
        total = +total + +durationEntry.duration;
      })

      const isWeekend = timesheetDate.day === "Sat" || timesheetDate.day === "Sun";
      let hideOTPopoverOnLoad = false;
      
      if (typeof(Cache.getItem('hideOTPopoverOnLoad')) !== "undefined") {
        hideOTPopoverOnLoad = Cache.getItem('hideOTPopoverOnLoad');
      }

      let otHours = 0;
      let tagOT = false;
      //add date as OT if total hours is more than 8
      if (total > 8) {
        durationEntries.filter(data => {
          if (data.date === timesheetDate.shortHandDate) {
            return data;
          }
          return null;
        }).forEach(timeEntry => {
          this.props.addOvertimeEntries(timeEntry.date, timeEntry.entry_id, hideOTPopoverOnLoad, otHours, tagOT);
        })
      }

      if (isNaN(total)) {
        total = 0;
      } else {
        total = +total.toFixed(2);
      }

      holidays && holidays.forEach(data => {
        if (timesheetMoment.isSame(data.date) && !holidaySpan) {
          holidaySpan = (
            <OverlayTrigger
              key="tooltip-date"
              placement="top"
              overlay={
                <Tooltip id={`tooltip-top`}>
                  {data.name || data.date}
                </Tooltip>
              }
            >
              <div className='holiday-color-text font-weight-bold'>HOL</div>
            </OverlayTrigger>
          );
        }
      });

      if (timesheetMoment.isAfter(moment())) {
        spendIndicator = FUTURE_DATE;
      } else if (isWeekend) {
        if (arrOTEntries.includes(timesheetDate.shortHandDate)) {
          spendIndicator = OVER_REQUIRED_HOURS
        }
        else {
          if (total > WORK_HOURS) {
            spendIndicator = OVER_REQUIRED_HOURS;
          } else if (total < WORK_HOURS) {
            spendIndicator = BELOW_REQUIRED_HOURS;
          }
        }
      } else {
        if (total > WORK_HOURS) {
          spendIndicator = OVER_REQUIRED_HOURS;
        } else if (total < WORK_HOURS) {
          spendIndicator = BELOW_REQUIRED_HOURS;
        }
      }

      return (
        <td className="align-center" key={key}>
          <b className={spendIndicator}>
            { Math.round(total) === total ? total : +total.toFixed(2) }
          </b>
          {holidaySpan}
        </td>
      )
    })

    if (timesheet.status === DRAFT 
      || timesheet.status === REJECTED 
      || (timesheet.status === APPROVED && !this.props.readOnly)
      || typeof(timesheet.status) === "undefined") {
      colspan = 4;
    }

    return (
      <tr>
        <td colSpan={colspan} className="align-right"><b>Total</b></td>
        {totalDurations}
        <td></td>
        <td></td>
      </tr>
    )
  }
}

const mapStateToProps = (state) => ({
  timesheets: state.timesheets,
  holidays: state.holidays 
})

const mapDispatchToProps = (dispatch) => {
  return {
    addOvertimeEntries: (...args) => dispatch(addOvertimeEntries(...args)),
    setOvertimeEntries: (...args) => dispatch(setOvertimeEntries(...args)),
    fetchHolidays: () => dispatch(fetchHolidays())
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(TotalDayHoursSpent)
